<template>
  <div>
    <dialogWrap
      v-model="show"
      title="退出运营"
      :width="'1050px'"
    >
      <el-form
        :model="params"
        ref="formAddPolicy"
        :rules="rules"
        label-width="110px"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item :label="`车牌号`" prop="plateNo">
              <span>{{ params.plateNo || '--' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="`VIN码`" prop="vin">
              <span>{{ params.vin || '--' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="`处置方式`" prop="disposalMethod">
              <el-select
                placeholder="请选择"
                v-model="params.disposalMethod"
                clearable
              >
                <el-option
                  v-for="item in disposalMethodList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item :label="`处置日期`" prop="disposalTime">
              <el-date-picker
                v-model="params.disposalTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="`处置人`" prop="disposalUserName">
              <el-input
                v-model="params.disposalUserName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="处置原因" prop="remarks">
              <el-input
                type="textarea"
                v-model="params.remarks"
                placeholder="请输入"
                maxlength="500"
                show-word-limit
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="`备注照片`"
              prop="remarkImg"
              class="remark_img"
            >
              <UploadCommon
                :fileList="remarkImg"
                :isAlone="false"
                :limit="1"
                :sizeType="4"
                commonUpload
                group="order"
                code="order_vehicle_note_pic"
              ></UploadCommon>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template slot="footer">
        <el-button @click="() => (this.show = false)" size="small"
          >取消</el-button
        >
        <el-button
          :loading="loading"
          @click="submit"
          size="small"
          type="primary"
          >确认处置</el-button
        >
      </template>
    </dialogWrap>
  </div>
</template>

<script>
import selectOption from '@/store/dict/selectOptionDict'
import { updateOperateState } from '@/api/domain/cars'

export default {
  model: {
    prop: 'disposalShow',
    event: 'change',
  },
  props: {
    disposalShow: {
      type: Boolean,
      default: false,
    },
    plateNo: {
      type: String,
      default: '',
    },
    vin: {
      type: [String, Number],
      default: '',
    },
    carId: {
      type: [String, Number],
      default: '',
    },
    carState: {
      type: [String, Number],
      default: -1,
    },
  },
  watch: {
    disposalShow(val) {
      this.show = val
      if (!val) {
        this.remarkImg = []
        this.$refs.formAddPolicy.resetFields()
        this.loading = false
        return
      }
      this.params.vin = this.vin
      this.params.plateNo = this.plateNo
    },
    show(val) {
      this.$emit('change', val)
    },
  },
  computed: {
    disposalMethodList() {
      if (Number(this.carState) === 5) {
        const list = this.dictParseList(selectOption.disposalMethodList)
        return list.filter((item) => Number(item?.value) === 1) // 只展示退回车源方
      }
      return this.dictParseList(selectOption.disposalMethodList)
    },
  },
  data() {
    return {
      show: false,
      loading: false,
      remarkImg: [],
      params: {
        plateNo: '',
        vin: '',
        disposalMethod: '',
        disposalTime: '',
        disposalUserName: '',
        remarkImg: '',
      },
      rules: {
        vin: [{ required: true, message: '车架号不能为空', trigger: 'blur' }],
        disposalMethod: [
          { required: true, message: '处置方式不能为空', trigger: 'change' },
        ],
        disposalTime: [
          { required: true, message: '处置日期不能为空', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    submit() {
      this.$refs.formAddPolicy.validate(async (valid) => {
        if (!valid) return this.$message.error('请填写必填项')
        this.loading = true
        const remarkImg = this.remarkImg.length > 0 ? [this.remarkImg?.[0]?.url] : []
        this.params.remarkImg = JSON.stringify(remarkImg)
        const { code } = await updateOperateState({
          ...this.params,
          id: this.carId,
          exitOperationState: 1,
        })
        if (code !== 1) {
          this.loading = false
          return false
        }
        this.show = false
        this.$emit('refresh')
        this.remarkImg = []
        this.$refs.formAddPolicy.resetFields()
        this.loading = false
      })
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .upload-box.notextType.hasTitle {
  min-height: auto !important;
}
</style>
